const TRUSTED_PARTNER_HELP_URL_BY_LOCALE: Record<string, string> = {
  en: 'https://help.sortlist.com/en/articles/11330857-trusted-partner-badge-a-proven-mark-of-trust-quality-and-stability',
  fr: 'https://help.sortlist.com/fr/articles/11330857-badge-trusted-partner-un-gage-eprouve-de-confiance-de-qualite-et-de-stabilite',
  nl: 'https://help.sortlist.com/nl/articles/11330857-betrouwbare-partner-badge-een-bewezen-teken-van-vertrouwen-kwaliteit-en-stabiliteit',
  de: 'https://help.sortlist.com/de/articles/11330857-trusted-partner-badge-ein-bewahrtes-zeichen-fur-vertrauen-qualitat-und-stabilitat',
  es: 'https://help.sortlist.com/es/articles/11330857-sello-trusted-partner-un-distintivo-de-confianza-calidad-y-estabilidad',
};

const DEFAULT_LOCALE = 'en';

/**
 * Returns the localized Trusted Partner help URL based on the provided locale.
 * Falls back to English if the locale is not supported.
 */
export const getTrustedPartnerHelpUrl = (locale: string): string => {
  return TRUSTED_PARTNER_HELP_URL_BY_LOCALE[locale] ?? TRUSTED_PARTNER_HELP_URL_BY_LOCALE[DEFAULT_LOCALE];
};
